import React from 'react';
import Head from 'next/head';

interface Props {
  data: Record<string, unknown>;
  keyName: string;
}

const JsonLd: React.FC<Props> = ({ data, keyName }): JSX.Element => (
  <Head>
    <script
      key={keyName}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  </Head>
);

export default JsonLd;
